import { render, staticRenderFns } from "./AttendanceRemote.vue?vue&type=template&id=382f3d4c"
import script from "./AttendanceRemote.vue?vue&type=script&lang=js"
export * from "./AttendanceRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports